export default __webpack_public_path__ + "static/about-zurnai-community-4bde905e7175413af4c8296f459c4b40.mp4";